import { SLChannelListPrelodAPIConfig } from '@/src/common/SLPreloadApi/Business/Configs/ChannelList';
import { HOME_PAGE_ERROR_CODE } from './constant';

export const ChannelListAPIConfig = new SLChannelListPrelodAPIConfig();

export const URL = {
  specialCommonPage: ChannelListAPIConfig.requestItems()?.[0].url({}) // 专区落地页
};

/**
 * 接口请求
 * @param url
 * @param data
 * @param params
 * @param headers
 * @param showLoading
 */
export async function pageRequest(url = '', data = {}, params = {}, headers = {}, showLoading = true): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const requestParams = {
    url,
    method: 'POST',
    params,
    data,
    headers,
    dataType: 'json',
  };
  // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  if (showLoading) {
    indicatorModule.showLoading();
  }
  return new Promise<any>((resolve, reject) => {
    const callback = (result: any) => {
      if (showLoading) {
        indicatorModule.hideLoading();
      }
      if (result.error) {
        reject(result);
      } else {
        if (result.data && result.data.code === 0) {
          resolve(result.data.data);
        } else {
          reject(result);
        }
      }
    };
    networkModule?.request?.(requestParams, callback);
  });
}

/**
 * 不在服务范围code
 */
export function isNotServiceWithCode(code: number) {
  if (code === undefined) {
    return false;
  }
  let result = false;
  switch (code) {
    case HOME_PAGE_ERROR_CODE.PRE_PAGE_LOGIN_CODE:
    case HOME_PAGE_ERROR_CODE.PRE_PAGE_NO_LOGIN_COE:
    case HOME_PAGE_ERROR_CODE.LOGIN_CODE:
    case HOME_PAGE_ERROR_CODE.NO_LOGIN_CODE:
    case HOME_PAGE_ERROR_CODE.NO_SERVICE:
      result = true;
      break;
    default:
      break;
  }
  return result;
}
